// ######################################################
// App.js - This is the backbone of the entire front-end
// app. The React Router determines which URL routes are
// available.
// * Modify this file to add new routes or to render new
// components to an existing routes.
// ######################################################

// Import dependencies
import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';
import cookie from 'js-cookie';
import { Modal, Button } from 'react-bootstrap';

// Import components to display
import Header from './components/reusables/header';
import { LandingPage, TermsPage } from './components/screens/public';
import { LiveStreamPage, VideoPlayer } from './components/screens/media';
import { ForgotPasswordPage, MemberLoginPage, RegistrationPage, PasswordResetPage, VerifyEmailPage } from './components/screens/member';
import {
  AdminLoginPage, LoginHistoryPage, AffiliateAdministrationPage,
  MemberAdministrationPage, MemberDetailPage, SpecialAccessPage, SettingsPage,
  VideoAnalyticsPage, VideoAnalyticsDetailPage, LivestreamAnalyticsPage
} from './components/screens/admin';

// Import styling used accross entire app
import './App.css';

// The base of the whole site
// Each Route is a different path within the main website and serves a corresponding component
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isIE: false,
      ieModalCleared: false,
      showIERisksModal: false
    }
  }

  componentDidMount = () => {

    // Detect if browser is IE
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    if (isIE) {
      this.setState({ isIE: true });
      console.log("IE detected")

      var ieModalCleared = cookie.get('ie-agreement');
      console.log("IE token: ", ieModalCleared);

      if (ieModalCleared) {
        console.log("Modal was previously cleared")
        this.setState({ ieModalCleared });
      } else {
        console.log("Diplay the modal")
        this.setState({ showIERisksModal: true });
      }
    }

  }

  acceptIERisks = () => {
    console.log("User has accepted IE risks")
    cookie.set('ie-agreement', true);
    this.setState({ ieModalCleared: true, showIERisksModal: false });
  }

  denyIERisks = () => {
    this.setState({ showIERisksModal: false });
  }

  render() {

    return (
      <div id='bodyComponent'>
        <div>
          <Router>
            <Switch>
              {/* Render without the sitewide header */}
              <Route exact path='/live' component={LiveStreamContainer} />
              <Route exact path='/' component={LandingPage} />
              <Route component={DefaultContainer} />
            </Switch>
          </Router>

          <Modal show={this.state.showIERisksModal} onHide={this.acceptIERisks} >
            <Modal.Header closeButton>
              <Modal.Title>An Important Message</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              We detect that you are using an outdated web browser (Internet Explorer). For the best experience we reccomend using Microsoft Edge, Mozilla Firefox or Google Chrome.
            </Modal.Body>
            <Modal.Footer>
              <Button variant="warning" onClick={this.acceptIERisks}>
                Click here to clear this message
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

// Display the landing page and live stream page without the sitewide header
const LiveStreamContainer = () => (
  <div style={{ padding: '0px', margin: '0px' }} className='container-fluid'>
    <Route exact path='/' render={() => <Redirect to='/live' />} />
    <Route exact path='/live' component={LiveStreamPage} />
  </div>
)


const DefaultContainer = () => (
  <div id='bodyComponent'>
    {/* Display all these pages with the header above page content */}
    <Header />
    <div style={{ height: '30px' }}></div>
    <div>
      <Route exact path='/login' component={MemberLoginPage} />
      <Route exact path='/register' component={RegistrationPage} />
      <Route exact path='/terms' component={TermsPage} />
      <Route exact path='/videos' component={VideoPlayer} />
      <Route exact path='/forgot' component={ForgotPasswordPage} />
      <Route path='/verify' component={VerifyEmailPage} />
      <Route path='/reset' component={PasswordResetPage} />
      <Route exact path='/admin' component={AdminLoginPage} />
      <Route exact path='/admin/history' component={LoginHistoryPage} />
      <Route exact path='/admin/affiliate' component={AffiliateAdministrationPage} />
      <Route exact path='/admin/members' component={MemberAdministrationPage} />
      <Route path='/admin/member' component={MemberDetailPage} />
      <Route exact path='/admin/special' component={SpecialAccessPage} />
      <Route exact path='/admin/settings' component={SettingsPage} />
      <Route path='/admin/analytics/video' component={VideoAnalyticsDetailPage} />
      <Route exact path='/admin/analytics/videos' component={VideoAnalyticsPage} />
      <Route exact path='/admin/analytics/livestream' component={LivestreamAnalyticsPage} />
    </div>
  </div>
)

export default App;
